import React, { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';
import classNames from 'classnames';

import AddPlaceButton from '../../../../common/components/add-place-button/AddPlaceButton';

import './NoResultsFullView.scss';

export interface NoResultsFullViewProps
  extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
  onAddPlaceClick?;
  children?: ReactNode;
}

const NoResultsFullView = ({
  className,
  onAddPlaceClick,
  children,
  ...props
}: NoResultsFullViewProps) => (
  <div className={classNames('no-results-full-view', className)} {...props}>
    <h1 className="no-results-full-view__title">Search result was not found</h1>
    <span className="no-results-full-view__description">
      Should this place be on the map?
    </span>
    {children}
    <AddPlaceButton
      className="no-results-full-view__add-place-button"
      onClick={onAddPlaceClick}
    />
  </div>
);

export default NoResultsFullView;
